if (!customElements.get('nw-product-carousel')) {
  customElements.define('nw-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.nw-pdp__track');
      if (!track) return;
      const slides = Array.from(track.querySelectorAll('[data-slide]'));
      const dots = Array.from(this.querySelectorAll('[data-dot]'));
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const listeners = [];
      let active = 0;
      let frame = 0;
      const position = slide => slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const max = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const update = () => {
        frame = 0;
        const current = track.scrollLeft;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const gap = Math.abs(Math.min(position(slide), max()) - current);
          if (gap < distance) { nearest = i; distance = gap; }
        });
        active = nearest;
        dots.forEach((dot, i) => {
          const duplicate = i > 0 && Math.abs(Math.min(position(slides[i]), max()) - Math.min(position(slides[i - 1]), max())) < 2;
          dot.hidden = duplicate;
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (previous) previous.disabled = current <= 2;
        if (next) next.disabled = current >= max() - 2;
      };
      const go = index => {
        if (!slides.length) return;
        const bounded = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left:Math.min(position(slides[bounded]), max()), behavior:reduceMotion.matches ? 'auto' : 'smooth'});
      };
      const listen = (target, event, handler, options) => {
        if (!target) return;
        target.addEventListener(event, handler, options);
        listeners.push(() => target.removeEventListener(event, handler, options));
      };
      listen(previous, 'click', () => go(active - 1));
      listen(next, 'click', () => go(active + 1));
      dots.forEach((dot, i) => listen(dot, 'click', () => go(i)));
      listen(track, 'scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
      listen(track, 'keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      update();
      this.cleanup = () => { listeners.forEach(remove => remove()); resize.disconnect(); if(frame)cancelAnimationFrame(frame); };
    }
    disconnectedCallback() { if(this.cleanup)this.cleanup(); this.cleanup = null; }
  });
}
